import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Home, Wallet, Hammer, FileText, MessageCircle, LogOut, KeyRound } from "lucide-react";
import { useAuth } from "@/lib/auth";

const TABS = [
  { to: "/buyer/home",       label: "Home",       Icon: Home,           tid: "tab-home" },
  { to: "/buyer/financials", label: "Financials", Icon: Wallet,         tid: "tab-financials" },
  { to: "/buyer/progress",   label: "Progress",   Icon: Hammer,         tid: "tab-progress" },
  { to: "/buyer/documents",  label: "Docs",       Icon: FileText,       tid: "tab-docs" },
  { to: "/buyer/tickets",    label: "Queries",    Icon: MessageCircle,  tid: "tab-tickets" },
];

export default function BuyerLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen rc-section flex flex-col">
      <header className="rc-frosted sticky top-0 z-40 border-b border-[var(--rc-line)]" style={{ minHeight: 60 }}>
        <div className="rc-container flex items-center justify-between gap-2 h-[60px]">
          <button onClick={() => nav("/buyer/home")} className="flex items-center gap-2 min-w-0" data-testid="logo-btn">
            <img src="/radiance-logo.jpeg" alt="Radiance Connect" className="w-9 h-9 rounded-lg object-cover flex-shrink-0" />
            <div className="leading-tight text-left min-w-0">
              <div className="rc-headline truncate" style={{ fontSize: 15 }}>Radiance Connect</div>
              <div className="rc-caption truncate">Hi, {user?.customer_name?.split(" ")[0] || "there"}</div>
            </div>
          </button>
          <div className="flex items-center gap-2 flex-shrink-0">
            <button onClick={() => nav("/buyer/handover")} className="rc-btn rc-btn-sm rc-btn-secondary !px-3" data-testid="handover-btn" title="Handover">
              <KeyRound size={16} /> <span className="hidden sm:inline">Handover</span>
            </button>
            <button onClick={logout} className="rc-btn rc-btn-sm rc-btn-ghost !px-2" data-testid="logout-btn" title="Logout">
              <LogOut size={18} />
            </button>
          </div>
        </div>
      </header>

      <main className="flex-1 pb-24">
        <div className="rc-container py-4 sm:py-5">
          <Outlet />
        </div>
      </main>

      <nav className="rc-tabbar rc-frosted" data-testid="bottom-tabbar">
        {TABS.map(({ to, label, Icon, tid }) => (
          <NavLink key={to} to={to} className={({ isActive }) => `rc-tab ${isActive ? "active" : ""}`} data-testid={tid}>
            {({ isActive }) => (
              <>
                <span className="rc-tab-dot" />
                <Icon size={22} strokeWidth={isActive ? 2 : 1.5} />
                <span>{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
